import React from "react";
import {Button, Card, Col, DatePicker, Form, Input, Row, Select, Space, Table} from "antd";
import {AuthenticatedGetToApi, AuthenticatedPostToApi, FILEDOWNLOADAuthenticatedPostToApi} from "../../helpers/api";
import {DownloadOutlined} from "@ant-design/icons";
const { RangePicker } = DatePicker;
const { Option } = Select;

function StopLog() {
    const [DepartmentList, SetDepartmentList] = React.useState([])
    const [dataSource, SetDataSource] = React.useState({})
    const [savedReq, SetSavedReq] = React.useState({})
    const [isLoading, setIsLoading] = React.useState(false)


    const generateStopTypeColumns = (countName) =>{
        return [
        {
            title: 'Race',
            dataIndex: 'Race',
            key: 'Race',
        },
        {
            title: '# of '+countName,
            dataIndex: 'Count',
            key: 'Count'
        },
            {
                title: '% of '+countName,
                dataIndex: 'Percent',
                key: 'Percent'
            }];
 
    }
  
    const onFinish = (values) => {
        setIsLoading(true)
        SetDataSource({})
        SetSavedReq(values)
        AuthenticatedPostToApi('/api/Report/StopLogReport',values).then(r=>{
            console.log(r)
            SetDataSource(r)
            setIsLoading(false)
        }).catch(()=>setIsLoading(false))
    };


    const runExport = async (pdf) => {
        setIsLoading(true)
        FILEDOWNLOADAuthenticatedPostToApi('/api/ReportExport/StopLogReport?pdf='+pdf,savedReq).then(r=>{
            setIsLoading(false)
            const blob = new Blob([r]);
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = `ReportExport-${+new Date()}.`+ (pdf?'pdf':'xlsx');
            link.click();
            link.remove();
        }).catch(()=>setIsLoading(false))
    }
    
    const LoadDepts = async () => {
        let r = await AuthenticatedGetToApi('/api/Central/MyDepartmentList')
        SetDepartmentList(r)
    }
    
    React.useEffect(()=>{
        LoadDepts();
    },[])
    
    return (
        <div>
            <Card size="small" title={"Stop Log Report"}  style={{ width: "100%", marginTop:10 }}>
                
                    <Form
                        initialValues={{ remember: true }}
                        onFinish={onFinish}
                        layout={"horizontal"}
                    >
                        <Space direction="horizontal">
                        <Form.Item
                            name="reportTitle"
                            rules={[{ required: true, message: 'Report Title is Required' }]}
                        >   
                            <Input addonBefore="Report Title"  placeholder="Report Title" allowClear={true} />
                        </Form.Item>
                            
                            
                        <Form.Item
                            name="sDept"
                            rules={[{ required: true, message: 'Department is Required' }]}
                        >   
                            <Select showSearch={true} placeholder={"Department"} style={{ width: 150 }} allowClear={true}>
                                {DepartmentList.map((v,idx)=>(
                                    <Option value={v.value?.toString()} key={'dept'+idx}>{v.key?.toString()}</Option>
                                ))}
                               
                            </Select>
                        </Form.Item>

                        <Form.Item
                            name="sStartDate"
                            rules={[{ required: true, message: 'Start Date is Required' }]}
                        >
                            <DatePicker allowClear={true} placeholder={'Start Date'} format={'MM/DD/YYYY'}/>
                        </Form.Item>
                        
                        <Form.Item
                            name="sEndDate"
                            rules={[{ required: true, message: 'End Date is Required' }]}
                        >
                            <DatePicker allowClear={true} placeholder={'End Date'} format={'MM/DD/YYYY'}/>
                        </Form.Item>

                        </Space>
                        <Form.Item>
                            <Button htmlType="submit" loading={isLoading}>
                                Generate Report
                            </Button>
                        </Form.Item>
                       
                    </Form>
                
            </Card>

            {Object.keys(dataSource).length>0 &&
                <Card size="small"  style={{ width: "100%", marginTop:10 }}>
                    <Button type="primary" icon={<DownloadOutlined />} style={{ marginLeft:10 }} onClick={()=>runExport(true)} loading={isLoading}>
                        Download PDF
                    </Button>
                    <Button type="primary" icon={<DownloadOutlined />} style={{ marginLeft:10 }} onClick={()=>runExport(false)} loading={isLoading}>
                        Download Excel
                    </Button>
                    
                    <h4>Stop Log</h4>
                    <Row>
                        <Col span={12}  style={{ width: "100%", padding:1 }}>
                            
                            <Card size="small" title={"Male Breakdown"}>
                                <Space direction="vertical">
                                    {(dataSource && dataSource.maleStops) &&
                                        <Table size="small" dataSource={dataSource.maleStops} columns={generateStopTypeColumns("Stops")} pagination={false}/>
                                    }
                                    <hr />
                                    {(dataSource && dataSource.maleSummonsIssued) &&
                                        <Table size="small" dataSource={dataSource.maleSummonsIssued} columns={generateStopTypeColumns("Summons Issued")} pagination={false}/>
                                    }
                                    <hr />
                                    {(dataSource && dataSource.maleWarningsIssued) &&
                                        <Table size="small" dataSource={dataSource.maleWarningsIssued} columns={generateStopTypeColumns("Warnings Issued")} pagination={false}/>
                                    }
                                    <hr />
    
                                    {(dataSource && dataSource.maleArrests) &&
                                        <Table size="small" dataSource={dataSource.maleArrests} columns={generateStopTypeColumns("Arrests")} pagination={false}/>
                                    }
                                </Space>
                            </Card>
                        </Col>
                        <Col span={12}  style={{ width: "100%", padding:1 }}>
                            <Card size="small" title={"Female Breakdown"}>
                                <Space direction="vertical">
                                    {(dataSource && dataSource.femaleStops) &&
                                        <Table size="small" dataSource={dataSource.femaleStops} columns={generateStopTypeColumns("Stops")} pagination={false}/>
                                    }
                                    <hr />
    
                                    {(dataSource && dataSource.femaleSummonsIssued) &&
                                        <Table size="small" dataSource={dataSource.femaleSummonsIssued} columns={generateStopTypeColumns("Summons Issued")} pagination={false}/>
                                    }
                                    <hr />
    
                                    {(dataSource && dataSource.femaleWarningsIssued) &&
                                        <Table size="small" dataSource={dataSource.femaleWarningsIssued} columns={generateStopTypeColumns("Warnings Issued")} pagination={false}/>
                                    }
                                    <hr />
    
                                    {(dataSource && dataSource.femaleArrests) &&
                                        <Table size="small" dataSource={dataSource.femaleArrests} columns={generateStopTypeColumns("Arrests")} pagination={false}/>
                                    }
                                </Space>
                            </Card>
                        </Col>
                    </Row>
    
                    <h4>Stop Log Age Breakdown</h4>
                    <Row>
                        <Col span={12}  style={{ width: "100%", padding:1 }}>
    
                            <Card size="small" title={"Male Breakdown"}>
                                <Space direction="vertical">
                                    {(dataSource && dataSource.maleUnder21) &&
                                        <Table size="small" dataSource={dataSource.maleUnder21} columns={generateStopTypeColumns("Under 21")} pagination={false}/>
                                    }
                                    <hr />
    
                                    {(dataSource && dataSource.male22and43) &&
                                        <Table size="small" dataSource={dataSource.male22and43} columns={generateStopTypeColumns("Between 22 and 43")} pagination={false}/>
                                    }
                                    <hr />
    
                                    {(dataSource && dataSource.male44and65) &&
                                        <Table size="small" dataSource={dataSource.male44and65} columns={generateStopTypeColumns("Between 44 and 65")} pagination={false}/>
                                    }
                                    <hr />
    
                                    {(dataSource && dataSource.maleOver66) &&
                                        <Table size="small" dataSource={dataSource.maleOver66} columns={generateStopTypeColumns("Over 66")} pagination={false}/>
                                    }
                                </Space>
                            </Card>
                        </Col>
                        <Col span={12}  style={{ width: "100%", padding:1 }}>
                            <Card size="small" title={"Female Breakdown"}>
                                <Space direction="vertical">
                                    {(dataSource && dataSource.femaleUnder21) &&
                                        <Table size="small" dataSource={dataSource.femaleUnder21} columns={generateStopTypeColumns("Under 21")} pagination={false}/>
                                    }
                                    <hr />
    
                                    {(dataSource && dataSource.female22and43) &&
                                        <Table size="small" dataSource={dataSource.female22and43} columns={generateStopTypeColumns("Between 22 and 43")} pagination={false}/>
                                    }
                                    <hr />
    
                                    {(dataSource && dataSource.female44and65) &&
                                        <Table size="small" dataSource={dataSource.female44and65} columns={generateStopTypeColumns("Between 44 and 65")} pagination={false}/>
                                    }
                                    <hr />
    
                                    {(dataSource && dataSource.femaleOver66) &&
                                        <Table size="small" dataSource={dataSource.femaleOver66} columns={generateStopTypeColumns("Over 66")} pagination={false}/>
                                    }
                                </Space>
                            </Card>
                        </Col>
                    </Row>



                    <h4>Stop Log Hispanic Ethnicity Breakdown</h4>
                    <Row>
                        <Col span={12}  style={{ width: "100%", padding:1 }}>

                            <Card size="small" title={"Male Breakdown"}>
                                <Space direction="vertical">
                                    {(dataSource && dataSource.hispanicMaleStops) &&
                                        <Table size="small" dataSource={dataSource.hispanicMaleStops} columns={generateStopTypeColumns("Stops")} pagination={false}/>
                                    }
                                    <hr />
                                    {(dataSource && dataSource.hispanicMaleSummonsIssued) &&
                                        <Table size="small" dataSource={dataSource.hispanicMaleSummonsIssued} columns={generateStopTypeColumns("Summons Issued")} pagination={false}/>
                                    }
                                    <hr />
                                    {(dataSource && dataSource.hispanicMaleWarningsIssued) &&
                                        <Table size="small" dataSource={dataSource.hispanicMaleWarningsIssued} columns={generateStopTypeColumns("Warnings Issued")} pagination={false}/>
                                    }
                                    <hr />

                                    {(dataSource && dataSource.hispanicMaleArrests) &&
                                        <Table size="small" dataSource={dataSource.hispanicMaleArrests} columns={generateStopTypeColumns("Arrests")} pagination={false}/>
                                    }
                                </Space>
                            </Card>
                        </Col>
                        <Col span={12}  style={{ width: "100%", padding:1 }}>
                            <Card size="small" title={"Female Breakdown"}>
                                <Space direction="vertical">
                                    {(dataSource && dataSource.hispanicFemaleStops) &&
                                        <Table size="small" dataSource={dataSource.hispanicFemaleStops} columns={generateStopTypeColumns("Stops")} pagination={false}/>
                                    }
                                    <hr />

                                    {(dataSource && dataSource.hispanicFemaleSummonsIssued) &&
                                        <Table size="small" dataSource={dataSource.hispanicFemaleSummonsIssued} columns={generateStopTypeColumns("Summons Issued")} pagination={false}/>
                                    }
                                    <hr />

                                    {(dataSource && dataSource.hispanicFemaleWarningsIssued) &&
                                        <Table size="small" dataSource={dataSource.hispanicFemaleWarningsIssued} columns={generateStopTypeColumns("Warnings Issued")} pagination={false}/>
                                    }
                                    <hr />

                                    {(dataSource && dataSource.hispanicFemaleArrests) &&
                                        <Table size="small" dataSource={dataSource.hispanicFemaleArrests} columns={generateStopTypeColumns("Arrests")} pagination={false}/>
                                    }
                                </Space>
                            </Card>
                        </Col>
                    </Row>

                    <h4>Stop Log Age Hispanic Ethnicity Breakdown</h4>
                    <Row>
                        <Col span={12}  style={{ width: "100%", padding:1 }}>

                            <Card size="small" title={"Male Breakdown"}>
                                <Space direction="vertical">
                                    {(dataSource && dataSource.hispanicMaleUnder21) &&
                                        <Table size="small" dataSource={dataSource.hispanicMaleUnder21} columns={generateStopTypeColumns("Under 21")} pagination={false}/>
                                    }
                                    <hr />

                                    {(dataSource && dataSource.hispanicMale22and43) &&
                                        <Table size="small" dataSource={dataSource.hispanicMale22and43} columns={generateStopTypeColumns("Between 22 and 43")} pagination={false}/>
                                    }
                                    <hr />

                                    {(dataSource && dataSource.hispanicMale44and65) &&
                                        <Table size="small" dataSource={dataSource.hispanicMale44and65} columns={generateStopTypeColumns("Between 44 and 65")} pagination={false}/>
                                    }
                                    <hr />

                                    {(dataSource && dataSource.hispanicMaleOver66) &&
                                        <Table size="small" dataSource={dataSource.hispanicMaleOver66} columns={generateStopTypeColumns("Over 66")} pagination={false}/>
                                    }
                                </Space>
                            </Card>
                        </Col>
                        <Col span={12}  style={{ width: "100%", padding:1 }}>
                            <Card size="small" title={"Female Breakdown"}>
                                <Space direction="vertical">
                                    {(dataSource && dataSource.hispanicFemaleUnder21) &&
                                        <Table size="small" dataSource={dataSource.hispanicFemaleUnder21} columns={generateStopTypeColumns("Under 21")} pagination={false}/>
                                    }
                                    <hr />

                                    {(dataSource && dataSource.hispanicFemale22and43) &&
                                        <Table size="small" dataSource={dataSource.hispanicFemale22and43} columns={generateStopTypeColumns("Between 22 and 43")} pagination={false}/>
                                    }
                                    <hr />

                                    {(dataSource && dataSource.hispanicFemale44and65) &&
                                        <Table size="small" dataSource={dataSource.hispanicFemale44and65} columns={generateStopTypeColumns("Between 44 and 65")} pagination={false}/>
                                    }
                                    <hr />

                                    {(dataSource && dataSource.hispanicFemaleOver66) &&
                                        <Table size="small" dataSource={dataSource.hispanicFemaleOver66} columns={generateStopTypeColumns("Over 66")} pagination={false}/>
                                    }
                                </Space>
                            </Card>
                        </Col>
                    </Row>
                    
                    
                </Card>
            }
            
        </div>
    );
}

export default StopLog;